export interface GameItem {
  id: number;
  title: string;
  category: string;
  tags: string[];
  rating: number;
  year: string;
  studio: string;
  type: string;
  desc: string;
  image: string;
  badge?: string;
}

export interface ReviewItem {
  id: number;
  title: string;
  cover: string;
  score: number;
  summary: string;
  pros: string[];
  cons: string[];
  meta: string;
  date: string;
}

export const beginnerGames: GameItem[] = [
  {
    id: 1,
    title: '樱色庭院',
    category: '纯爱向',
    tags: ['校园', '甜蜜', '短篇'],
    rating: 8.6,
    year: '2023',
    studio: 'MellowForge',
    type: '入门首选',
    desc: '节奏轻快的校园纯爱小品，流程适中、系统简单，适合第一次接触工口游戏的新手，能快速感受这类作品的叙事魅力。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20cherry%20blossom%20school%20courtyard%20at%20dusk%2C%20soft%20pink%20petals%20drifting%2C%20a%20girl%20silhouette%20under%20a%20tree%2C%20warm%20crimson%20and%20gold%20lighting%2C%20romantic%20dreamy%20atmosphere%2C%20clean%20composition%20without%20text&width=600&height=400&seq=eroge-beginner-1&orientation=landscape',
  },
  {
    id: 2,
    title: '夜航星图',
    category: '奇幻向',
    tags: ['冒险', '剧情', '世界观'],
    rating: 8.9,
    year: '2022',
    studio: 'StarCanvas',
    type: '剧情入坑',
    desc: '以浪漫奇幻世界为背景的长篇冒险，世界观细腻、角色鲜活，剧本分量足，是许多玩家公认的剧情向入坑之作。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20fantasy%20night%20sky%20with%20a%20constellation%20constellation%20and%20a%20flying%20airship%2C%20deep%20navy%20and%20crimson%20nebula%2C%20epic%20adventure%20feeling%2C%20a%20hero%20and%20companion%20silhouettes%2C%20dramatic%20warm%20light%2C%20clean%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-beginner-2&orientation=landscape',
  },
  {
    id: 3,
    title: '暮色咖啡馆',
    category: '治愈系',
    tags: ['日常', '温暖', '轻松'],
    rating: 8.4,
    year: '2024',
    studio: 'WarmBrew',
    type: '治愈入门',
    desc: '发生在街角咖啡馆的日常群像剧，氛围温暖、对话自然，主打轻松治愈的节奏，适合工作学习之余放松心情。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20cozy%20evening%20cafe%20interior%20with%20warm%20amber%20lights%2C%20steaming%20coffee%20cups%2C%20a%20barista%20girl%20by%20the%20counter%2C%20soft%20golden%20glow%2C%20relaxing%20slice-of-life%20atmosphere%2C%20clean%20composition%20without%20text&width=600&height=400&seq=eroge-beginner-3&orientation=landscape',
  },
  {
    id: 4,
    title: '霓虹回响',
    category: '科幻向',
    tags: ['赛博朋克', '悬疑', '成长'],
    rating: 8.7,
    year: '2023',
    studio: 'PixelDawn',
    type: '潮流尝试',
    desc: '融合赛博朋克设定的近未来群像，画面风格鲜明、音乐出色，在主流玩家中也积累了不错的口碑，适合尝鲜。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20neon%20cyberpunk%20city%20street%20at%20night%2C%20crimson%20and%20amber%20neon%20signs%2C%20rain%20reflections%2C%20a%20girl%20with%20glowing%20hair%2C%20moody%20futuristic%20atmosphere%2C%20clean%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-beginner-4&orientation=landscape',
  },
];

export const rankingGames: GameItem[] = [
  {
    id: 11,
    title: '苍蓝传说',
    category: '剧情向',
    tags: ['史诗', '群像', '多结局'],
    rating: 9.5,
    year: '2021',
    studio: 'LegendWorks',
    type: '口碑神作',
    desc: '以王国兴衰为背景的多线群像史诗，剧本深度与角色刻画俱佳，稳居各类工口游戏排行榜榜首多年。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20an%20epic%20fantasy%20kingdom%20battle%20scene%20with%20a%20hero%20holding%20a%20glowing%20sword%2C%20crimson%20banners%20and%20golden%20light%2C%20grand%20war%20atmosphere%2C%20detailed%20characters%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-rank-1&orientation=landscape',
  },
  {
    id: 12,
    title: '星之絮语',
    category: '治愈系',
    tags: ['温情', '日常', '长线'],
    rating: 9.2,
    year: '2020',
    studio: 'AuroraSoft',
    type: '治愈榜王',
    desc: '用一整季的日常陪伴讲出一个动人的成长故事，节奏舒缓、情感细腻，是治愈系榜单的常青树。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20girl%20gazing%20at%20a%20starry%20night%20sky%20from%20a%20hill%2C%20shooting%20stars%2C%20soft%20aurora%20in%20crimson%20and%20teal%2C%20tender%20peaceful%20mood%2C%20clean%20composition%20without%20text&width=600&height=400&seq=eroge-rank-2&orientation=landscape',
  },
  {
    id: 13,
    title: '赤色物语',
    category: '纯爱向',
    tags: ['催泪', '青春', '催泪'],
    rating: 9.0,
    year: '2022',
    studio: 'CrimsonNote',
    type: '口碑榜',
    desc: '被许多玩家称为「哭出来的神作」，情感浓度极高，青春与遗憾交织，成为纯爱向入坑必玩。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20two%20youths%20under%20a%20red%20maple%20tree%20in%20autumn%2C%20falling%20leaves%2C%20bitter%20sweet%20nostalgic%20mood%2C%20warm%20crimson%20and%20amber%20palette%2C%20cinematic%20emotional%20composition%20without%20text&width=600&height=400&seq=eroge-rank-3&orientation=landscape',
  },
  {
    id: 14,
    title: '迷宫彼端',
    category: '悬疑向',
    tags: ['解谜', '反转', '沉浸'],
    rating: 8.8,
    year: '2023',
    studio: 'Labyrinth',
    type: '悬疑榜',
    desc: '将沉浸式解谜与剧情叙事结合的创新之作，层层反转令人欲罢不能，悬疑爱好者的心头好。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20mysterious%20glowing%20labyrinth%20with%20floating%20crimson%20particles%2C%20a%20girl%20exploring%20with%20a%20lantern%2C%20mysterious%20suspenseful%20atmosphere%2C%20dark%20and%20gold%20palette%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-rank-4&orientation=landscape',
  },
  {
    id: 15,
    title: '焰火前夜',
    category: '青春向',
    tags: ['夏祭', '群像', '心动'],
    rating: 8.7,
    year: '2024',
    studio: 'Festival',
    type: '新作榜',
    desc: '以夏日祭典为舞台的青春群像，画面清新、配乐动人，是近期最受好评的新作之一。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20summer%20festival%20with%20fireworks%20bursting%20in%20crimson%20and%20gold%2C%20lanterns%2C%20a%20girl%20in%20yukata%2C%20joyful%20youthful%20atmosphere%2C%20vivid%20clean%20composition%20without%20text&width=600&height=400&seq=eroge-rank-5&orientation=landscape',
  },
  {
    id: 16,
    title: '风之彼岸',
    category: '奇幻向',
    tags: ['冒险', '浪漫', '宏大'],
    rating: 8.6,
    year: '2019',
    studio: 'WindSaga',
    type: '经典榜',
    desc: '经典老牌奇幻冒险，格局宏大、角色众多，是许多老玩家心中的启蒙之作。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20wind-swept%20mountain%20pass%20with%20sailing%20clouds%2C%20an%20adventurer%20girl%20with%20flowing%20hair%2C%20golden%20sunlight%20and%20crimson%20sky%2C%20epic%20fantasy%20mood%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-rank-6&orientation=landscape',
  },
];

export const masterpieceGames: GameItem[] = [
  {
    id: 21,
    title: '永恒之诗',
    category: '史诗向',
    tags: ['经典', '神作', '必玩'],
    rating: 9.8,
    year: '2016',
    studio: 'EternalPoem',
    type: '时代里程碑',
    desc: '公认的时代里程碑，无论剧本、音乐还是画面都代表了一个阶段的巅峰，是每个工口游戏玩家的必修课。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20an%20ancient%20glowing%20book%20with%20floating%20golden%20runes%2C%20a%20majestic%20library%20at%20dusk%2C%20crimson%20and%20gold%20grand%20atmosphere%2C%20timeless%20epic%20mood%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-master-1&orientation=landscape',
  },
  {
    id: 22,
    title: '深海回廊',
    category: '悬疑向',
    tags: ['心理', '神展开', '神作'],
    rating: 9.6,
    year: '2018',
    studio: 'AbyssLab',
    type: '叙事天花板',
    desc: '以心理学与叙事结构见长的神展开之作，玩过之后会久久难以释怀，被誉为叙事天花板。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20deep%20ocean%20corridor%20with%20glowing%20crimson%20light%20from%20below%2C%20a%20silhouette%20of%20a%20girl%20diving%2C%20mysterious%20dark%20blue%20and%20crimson%2C%20psychological%20suspense%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-master-2&orientation=landscape',
  },
  {
    id: 23,
    title: '绯红契约',
    category: '黑暗向',
    tags: ['暗黑', '命运', '神作'],
    rating: 9.5,
    year: '2017',
    studio: 'CrimsonPact',
    type: '暗黑美学',
    desc: '以独特暗黑美学与宿命主题著称，在压抑中开出绝美之花，是黑暗向作品的代表作。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20dark%20gothic%20throne%20room%20with%20red%20candlelight%2C%20a%20girl%20in%20elegant%20black%20and%20crimson%20attire%2C%20a%20contract%20seal%20glowing%20golden%2C%20dark%20romantic%20gothic%20mood%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-master-3&orientation=landscape',
  },
  {
    id: 24,
    title: '雾都来信',
    category: '剧情向',
    tags: ['推理', '温情', '神作'],
    rating: 9.4,
    year: '2019',
    studio: 'FogLetter',
    type: '推理佳作',
    desc: '把推理与温情融合得恰到好处，案件环环相扣，情感层层递进，是剧情党的不二之选。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%20of%20a%20foggy%20old%20town%20street%20with%20streetlamps%2C%20a%20girl%20holding%20a%20sealed%20letter%2C%20mysterious%20warm%20crimson%20and%20amber%20light%2C%20detective%20mood%2C%20cinematic%20composition%20without%20text&width=600&height=400&seq=eroge-master-4&orientation=landscape',
  },
];

export const reviewList: ReviewItem[] = [
  {
    id: 31,
    title: '苍蓝传说 评测：为什么它是口碑神作',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20key%20visual%20of%20an%20epic%20kingdom%20battle%20with%20a%20hero%20and%20crimson%20banners%2C%20golden%20rays%2C%20grand%20composition%2C%20high%20detail%20fantasy%20artwork%2C%20cinematic%20lighting%20without%20text&width=800&height=450&seq=eroge-review-1&orientation=landscape',
    score: 9.5,
    summary: '一款把「角色」放在第一位的群像史诗。它不是靠华丽开场抓住你，而是用几小时的时间，让每一个角色都长在了心里。',
    pros: ['角色塑造极为立体', '剧本结构严谨完整', '多结局重复游玩价值高', '音乐氛围一流'],
    cons: ['前期节奏偏慢', '部分分支较难达成'],
    meta: '剧情向 · 冒险 · 平均通关 40h',
    date: '2024-05-12',
  },
  {
    id: 32,
    title: '星之絮语 评测：治愈系该有的样子',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20key%20visual%20of%20a%20girl%20under%20a%20starry%20sky%20with%20soft%20aurora%20and%20stars%2C%20tender%20peaceful%20mood%2C%20crimson%20and%20gold%20tones%2C%20clean%20cinematic%20artwork%20without%20text&width=800&height=450&seq=eroge-review-2&orientation=landscape',
    score: 9.2,
    summary: '它不做煽情，只做陪伴。一整季的日常下来，你会突然发现，原来平凡里藏着最深的温柔。',
    pros: ['情绪渲染自然', '日常节奏舒适', '音乐治愈耐听'],
    cons: ['剧情冲突较弱', '部分玩家会觉得平淡'],
    meta: '治愈系 · 日常 · 平均通关 25h',
    date: '2024-06-03',
  },
  {
    id: 33,
    title: '赤色物语 评测：哭到停不下来的青春',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20key%20visual%20of%20two%20youths%20under%20a%20red%20maple%20tree%2C%20autumn%20leaves%20falling%2C%20emotional%20nostalgic%20mood%2C%20crimson%20and%20amber%20warmth%2C%20cinematic%20artwork%20without%20text&width=800&height=450&seq=eroge-review-3&orientation=landscape',
    score: 9.0,
    summary: '青春最残酷的地方在于，它一定会有遗憾。而这款游戏，把遗憾写得如此动人，让人心甘情愿被刀。',
    pros: ['情感冲击力极强', '对白真诚', '配乐与剧情完美契合'],
    cons: ['题材较为致郁', '部分结局较虐'],
    meta: '纯爱向 · 青春 · 平均通关 18h',
    date: '2024-07-01',
  },
  {
    id: 34,
    title: '迷宫彼端 评测：反转不断的沉浸解谜',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20key%20visual%20of%20a%20glowing%20mysterious%20labyrinth%20with%20crimson%20particles%2C%20a%20girl%20with%20a%20lantern%2C%20suspenseful%20dark%20mood%2C%20gold%20and%20crimson%2C%20cinematic%20artwork%20without%20text&width=800&height=450&seq=eroge-review-4&orientation=landscape',
    score: 8.8,
    summary: '把解谜玩法和剧情叙事结合得很好，每一次以为猜到了真相，都会被下一层反转打脸，沉浸感拉满。',
    pros: ['反转设计精妙', '谜题与叙事结合紧密', '氛围营造出色'],
    cons: ['部分谜题难度偏高', '二周目新鲜感下降'],
    meta: '悬疑向 · 解谜 · 平均通关 22h',
    date: '2024-07-20',
  },
  {
    id: 35,
    title: '暮色咖啡馆 评测：下班后的治愈时光',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20key%20visual%20of%20a%20warm%20evening%20cafe%20interior%20with%20amber%20lights%20and%20coffee%2C%20a%20barista%20girl%2C%20cozy%20relaxed%20slice-of-life%20mood%2C%20crimson%20and%20gold%20warmth%2C%20cinematic%20artwork%20without%20text&width=800&height=450&seq=eroge-review-5&orientation=landscape',
    score: 8.4,
    summary: '没有宏大的叙事，只有一杯咖啡和一个温暖的夜晚。适合在疲惫的时候打开，让心情慢慢平静下来。',
    pros: ['氛围治愈', '对话自然有趣', '流程短适合碎片时间'],
    cons: ['内容量偏少', '剧情深度有限'],
    meta: '治愈系 · 日常 · 平均通关 8h',
    date: '2024-08-05',
  },
];

export const faqList = [
  {
    q: '什么是工口游戏？第一次接触该怎么选？',
    a: '工口游戏是指以恋爱、情感与剧情为核心，并包含成人向内容的一类文字冒险游戏。第一次接触建议从流程较短、剧情温和的纯爱或治愈向作品入手（例如「暮色咖啡馆」），先感受叙事节奏与操作方式，再逐步尝试剧情更深、内容更丰富的作品。',
  },
  {
    q: '工口游戏和普通视觉小说有什么区别？',
    a: '两者同属文字冒险大类，但工口游戏通常以恋爱与情感发展为主线，并包含成人向的剧情内容。选择时主要看自己的接受度，可以从分级与平台说明判断内容浓度，入门期选择轻量作品会更容易适应。',
  },
  {
    q: '玩工口游戏需要什么设备或配置？',
    a: '绝大多数工口游戏都是轻量级文字冒险游戏，对硬件要求很低，普通笔记本即可流畅运行。不过部分3D或演出丰富的作品会需要独立显卡，建议在入手前查看官方的最低配置要求。',
  },
  {
    q: '在哪里可以获取和游玩这些游戏？',
    a: '请在作品的官方发行平台或授权商店购买正版游玩。本网站仅提供推荐与评测内容，帮助你挑选作品，不提供任何下载链接。支持正版，才能让创作者持续产出好作品。',
  },
  {
    q: '为什么有些作品评分高但评价两极分化？',
    a: '工口游戏非常吃个人口味：剧情向、治愈向、悬疑向的受众差异很大。评分高通常代表整体质量优秀，但适不适合你，还要看题材、节奏和情感取向是否对味，这也是本站坚持提供详细评测的原因。',
  },
];

export const categoryStats = [
  { name: '剧情向', count: 128, icon: 'ri-quill-pen-line' },
  { name: '纯爱向', count: 96, icon: 'ri-heart-3-line' },
  { name: '治愈系', count: 74, icon: 'ri-sun-foggy-line' },
  { name: '悬疑向', count: 58, icon: 'ri-search-eye-line' },
  { name: '奇幻向', count: 83, icon: 'ri-sparkling-2-line' },
  { name: '科幻向', count: 47, icon: 'ri-rocket-2-line' },
];